import _ from 'lodash';

/**
 * @description sorts object keys in the prder of the array provided and returns the object
 * @param object
 * @param orderedArray
 */
export const sortObjectWithArray = (
  object: Record<string, unknown>,
  orderedArray: Array<any>,
): Record<string, unknown> => {
  return _(object)
    .toPairs()
    .sort((a, b) => {
      const [aVal] = a;
      const [bVal] = b;

      return orderedArray.indexOf(aVal) - orderedArray.indexOf(bVal);
    })
    .fromPairs()
    .value();
};
